'use client'

import React, { createContext, ReactNode } from 'react'

interface TabbedPanelContextValue {
    panelId: string
}

export const TabbedPanelContext = createContext<TabbedPanelContextValue | null>(null)

interface TabbedPanelProviderProps {
    value: TabbedPanelContextValue
    children: ReactNode
}

export const TabbedPanelProvider = ({ value, children }: TabbedPanelProviderProps) => {
    return <TabbedPanelContext.Provider value={value}> {children} </TabbedPanelContext.Provider>
}
